// extracted by mini-css-extract-plugin
export default {"list":"relationship-status_list__OXEBM","arrow_icon":"relationship-status_arrow_icon__Z3Tdo"};